import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography } from '@mui/material'
import GenerousQuote from '../../components/FundApiComponents/SplashComponents/GenerousQuote'
import TwoColumnBulleted from '../../components/FundApiComponents/SplashComponents/TwoColumnBulleted'
import GenerousInfographic from '../../components/GenerousInfographic'
import AboutUsBanner from '../../components/AboutUsBanner'
import Html from '../../components/Html/Html'
import ImageTextColumns from '../../components/FundApiComponents/SplashComponents/ImageTextColumns'
import ContentWrapper from '../../components/ContentWrapper'
import { useSideNavigationContext } from '../../utils/context/sideNavigationContext'
import CategoryInsightList from '../../components/CategoryInsightList'

import { LoadableWistiaVideo } from '../../components/Loaders/loadableComponents' // Adjust the path accordingly

const FundSplash = ({ splashSection, id, index, relatedArticles }) => {
  const { product_splash_page: content } = splashSection ?? {}
  const { content_blocks: contentBlocks = [] } = content?.[0] ?? {}

  const { createSectionRef } = useSideNavigationContext()

  return (
    <div id={id} ref={createSectionRef(index)}>
      {contentBlocks.map((block, contentBlockIndex) => {
        if (block.wistia_video) {
          return (
            <ContentWrapper key={contentBlockIndex} size="large" noMargin>
              <LoadableWistiaVideo
                key={contentBlockIndex}
                id={block.wistia_video.wistia_video_id}
              />
            </ContentWrapper>
          )
        }
        if (block.banner) {
          return (
            <AboutUsBanner
              key={contentBlockIndex}
              componentProps={block.banner}
            />
          )
        }
        if (block.text_plus_image) {
          return (
            <ImageTextColumns
              key={contentBlockIndex}
              data={block.text_plus_image}
            />
          )
        }
        if (block.generous_quote) {
          return (
            <GenerousQuote
              key={contentBlockIndex}
              data={block.generous_quote}
            />
          )
        }
        if (block.infographic) {
          return (
            <GenerousInfographic
              key={contentBlockIndex}
              data={block.infographic}
            />
          )
        }
        if (block.bulleted_icons) {
          return (
            <TwoColumnBulleted
              key={contentBlockIndex}
              data={block.bulleted_icons}
            />
          )
        }
        if (block.html_block) {
          return (
            <div key={contentBlockIndex}>
              {block.html_block.title && (
                <Typography variant="h2" color="textPrimary">
                  {block.html_block.title}
                </Typography>
              )}
              {block.html_block.html && (
                <Html content={block.html_block.html} />
              )}
            </div>
          )
        }
        if (block.category_insight_list) {
          return (
            <Stack key={contentBlockIndex} flexDirection="column">
              <CategoryInsightList
                {...block.category_insight_list}
                insightArticlesOverride={relatedArticles}
              />
            </Stack>
          )
        }

        return null
      })}
    </div>
  )
}

FundSplash.propTypes = {
  splashSection: PropTypes.shape({
    product_splash_page: PropTypes.arrayOf(
      PropTypes.shape({
        content_blocks: PropTypes.arrayOf(PropTypes.object),
      })
    ),
  }),
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  relatedArticles: PropTypes.array, // Define the shape based on usage
}

export default FundSplash